<template>
<div>
    <b-form inline class="mt-3">
        <b-form-group :label="$t('Verwerter')" v-if="fields.includes('Verwerter')">
            <b-form-select v-model="verwerterSelected"
                    :options="verwerter"
                    text-field="name"
                    value-field="id"
                    name="verwerter"
                    class="custom-select">
            </b-form-select>
        </b-form-group>
        <b-form-group :label="$t('Betrieb')" v-if="fields.includes('Betrieb')">
            <b-form-select v-model="betriebSelected"
                    :options="betriebe"
                    text-field="AGIS"
                    value-field="ID"
                    name="betrieb"
                    class="custom-select">
            </b-form-select>
        </b-form-group>
        <b-form-group :label="$t('Von')" v-if="fields.includes('Von')">
            <!-- Die Doku ist etwas versteckt: node_modules/vue-monthly-picker/src/app.vue -->
            <vue-monthly-picker v-model="vonMonth" dateFormat="MM.YYYY" placeHolder="2018-12" inputClass="input" :monthLabels="monate"></vue-monthly-picker>
        </b-form-group>
        <b-form-group :label="$t('Bis')" v-if="fields.includes('Bis')">
            <vue-monthly-picker v-model="bisMonth" dateFormat="MM.YYYY" placeHolder="2018-12" inputClass="input" :monthLabels="monate"></vue-monthly-picker>
        </b-form-group>
        <b-form-group :label="$t('Probetyp')" v-if="fields.includes('Probetyp')">
            <b-form-select v-model="anatypSelected" class="form-control"
                    id ="anatyp"
                    :options="anatyp"
                    :text-field="anatypKey"
                    value-field="AnatypID">
            </b-form-select>
        </b-form-group>
        <b-form-group :label="$t('Tierart')" v-if="fields.includes('Tierart')">
            <b-form-select v-model="tierartSelected"
                    :options="tierarten"
                    text-field="name"
                    value-field="id">
            </b-form-select>
        </b-form-group>
    </b-form>
    <br>
</div>

</template>

<script>
import {  i18n } from "../main";
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  name: "search",
  components: { VueMonthlyPicker },
  props: {
    fields: {
      type: String,
      default: "Betrieb,Von,Bis"
    },
    anaTabGraphic: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      anatypKey: "AnatypName_" + this.$route.params.lang,
      //tierartNameKey: 'TierartName_'+this.$route.params.lang,
      monate: [
        this.$t("mmm_01"),
        this.$t("mmm_02"),
        this.$t("mmm_03"),
        this.$t("mmm_04"),
        this.$t("mmm_05"),
        this.$t("mmm_06"),
        this.$t("mmm_07"),
        this.$t("mmm_08"),
        this.$t("mmm_09"),
        this.$t("mmm_10"),
        this.$t("mmm_11"),
        this.$t("mmm_12")
      ]
      //anaTabGraphic: false
    };
  },
  computed: {
    verwerter() {
      let alleVerwerter = [{ id: 0, name: i18n.t("Alle").toLowerCase() }];
      //return alleVerwerter.concat(this.$store.state.mengenStore.verwerter)
      for (let i = 0; i < this.$store.state.mengenStore.verwerter.length; i++)
        alleVerwerter.push({
          id: this.$store.state.mengenStore.verwerter[i].ID,
          name:
            this.$store.state.mengenStore.verwerter[i].NAME +
            " - " +
            this.$store.state.mengenStore.verwerter[i].MBHID
        });
      return alleVerwerter;
    },
    verwerterSelected: {
      get: function() {
        return this.$store.state.mengenStore.verwerterSelected;
      },
      set: function(perid) {
        this.$store.commit("setVerwerterSelected", perid);
        this.$emit("filterdata");
      }
    },
    betriebe() {
      let alleBetriebe = [{ ID: 0, AGIS: i18n.t("Alle").toLowerCase() }];
      return alleBetriebe.concat(this.$store.state.betriebeStore.betriebe.list);
    },
    betriebSelected: {
      get: function() {
        return this.$store.state.searchStore.searchValues.betriebSelected;
      },
      set: function(btrid) {
        this.$store.commit("setBetriebSelected", btrid);
        this.$emit("filterdata");
      }
    },
    anatyp() {
      let alleAnatypen = this.anaTabGraphic
        ? []
        : [
            {
              AnatypID: null,
              AnatypName_de: "alle",
              AnatypName_fr: "tout",
              AnatypName_it: "tutto"
            }
          ];
      return alleAnatypen.concat(this.$store.state.analysenStore.anatyp);
    },
    anatypSelected: {
      get: function() {
        return this.$store.state.analysenStore.anatypSelected;
      },
      set: function(value) {
        this.$store.dispatch("setAnatypSelected", value);
        this.$emit("filterdata");
      }
    },
    tierarten() {
      //var tierarten = [ { "id": 0, "name": i18n.t("Alle").toLowerCase() } ]
      var tierarten = [];
      for (
        var i = 0;
        i < this.$store.state.searchStore.searchValues.tierarten.length;
        i++
      )
        tierarten.push({
          id: this.$store.state.searchStore.searchValues.tierarten[i].id,
          name: this.$store.state.searchStore.searchValues.tierarten[i].name[
            i18n.locale
          ]
        });
      return tierarten;
    },
    tierartSelected: {
      get: function() {
        return this.$store.state.searchStore.searchValues.tierartSelected;
      },
      set: function(value) {
        this.$store.dispatch("setTierartSelected", value);
        this.$emit("filterdata");
      }
    },
    vonMonth: {
      get: function() {
        return moment(this.$store.state.searchStore.searchValues.von).format(
          "YYYY-MM"
        );
      },
      set: function(value) {
        value = value.toDate(); // monthpicker returns a Moment!
        this.$store.commit("setVon", value);
        this.$emit("filterdata");
      }
    },
    bisMonth: {
      get: function() {
        return moment(this.$store.state.searchStore.searchValues.bis).format(
          "YYYY-MM"
        );
      },
      set: function(value) {
        value = value
          .add(1, "months")
          .add(-1, "days")
          .toDate(); // monthpicker returns a Moment!
        this.$store.commit("setBis", value);
        this.$emit("filterdata");
      }
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(async function() {
      if (self.anaTabGraphic == true) {
        self.anatypSelected = 1;
      }
    });
  }
};
</script>

<style>
legend.col-form-label {
  margin-right: 10px;
}
</style>